var map = {
	"./Google.svg": "1ff1",
	"./beauty.svg": "a683",
	"./cat.svg": "65c0",
	"./cat2.svg": "559f",
	"./check.svg": "6aa8",
	"./eco.svg": "e4c3",
	"./electronic.svg": "f9e8",
	"./fb-white.svg": "3e63",
	"./fb.svg": "cc3b",
	"./garden.svg": "6472",
	"./homegoods.svg": "e2c8",
	"./instagram.svg": "55b4",
	"./jeweleries.svg": "cad3",
	"./menu.svg": "869f",
	"./telegram-white.svg": "f36c",
	"./telegram.svg": "7315",
	"./twitter.svg": "b988",
	"./watch.svg": "836e",
	"./youtube.svg": "21f8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";